import { CircularProgress } from "@mui/material";

import "./css/loading.css";

const Loading = () => {
    return (
        <div className="loading">
            <CircularProgress />
        </div>
    );
}

export default Loading;